import React from 'react';
import { Container } from 'semantic-ui-react';
import Link from './Link';
import InlineSvg from './InlineSvg';
import { toSnakeCase } from '../helpers/common';

const ContactUs = (props) => {
  const { anchorTagLinkText } = props;

  return (
    <section className="contact-us__section" id={anchorTagLinkText && `${toSnakeCase(anchorTagLinkText)}`}>
      <Container className="contact-us__container">
        <div className="grid-wrapper">
          <div className="contact-us__grid-container">
            {/* Faults & Emergencies Column */}
            <div className="contact-us__grid-column contact-us__column-one">
              <InlineSvg name="icon-streetlamp" color="white" />
              <h3 className="image-and-content-rl__title">Faults and emergencies</h3>
              <p>
                If your enquiry is in relation to electrical faults you can report easily via our{' '}
                <Link target="_blank" title="Online reporting tool" to="https://myenergy.powercor.com.au/s/report-a-fault">
                  online reporting tool
                </Link>{' '}
                or in case of emergency please call our 24 hour service line.
              </p>
              <ul className="link-list ">
                <li className="link-list__item">
                  <a href="tel:132412" className="external-link ">
                    Powercor 13 24 12
                  </a>
                </li>
                <li className="link-list__item">
                  <a href="tel:131280" className="external-link ">
                    CitiPower 13 12 80
                  </a>
                </li>
                <li className="link-list__item">
                  <a href="tel:131450" className="external-link ">
                    Interpreter services 13 14 50
                  </a>
                </li>
              </ul>
            </div>

            {/* Feedback & Enquiries Column */}
            <div className="contact-us__grid-column contact-us__column-two">
              <div className="contact-us__icon-wrapper">
                <InlineSvg name="icon-feedback" />
              </div>
              <h3 className="image-and-content-rl__title">Feedback and enquiries</h3>
              <p>We welcome general enquiries to our Customer Service Agents either online or via phone. This includes calls about:</p>
              <ul>
                <li>Connection inquiries</li>
                <li>Trees or vegetation near powerlines</li>
                <li>Electrical safety</li>
                <li>Our network activities within your community.</li>
              </ul>
              <p>Please use the enquiry form below or contact us directly during business hours on:</p>
              <Link to="/contact-us/general-enquiry/" className="button button--outline listing-block-reversible__button">
                Enquire Online
              </Link>
              <ul className="link-list ">
                <li className="link-list__item">
                  <a href="tel:132206" className="external-link ">
                    Powercor 13 22 06
                  </a>
                </li>
                <li className="link-list__item">
                  <a href="tel:1300301101" className="external-link ">
                    CitiPower 1300 301 101
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default ContactUs;
